import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import thunkMiddleware from 'redux-thunk'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import auth from './Auth'
import orders from './Orders'
import venues from './Venues'
import revenueCenters from './RevenueCenters'
import menus from './Menus'

const persistAuthConfig = {
  storage,
  key: 'root',
  whitelist: ['auth'],
}

const persistVenuesConfig = {
  storage,
  key: 'venues',
  whitelist: ['selectedId'],
}

const rootReducer = combineReducers({
  venues: persistReducer(persistVenuesConfig, venues),
  auth,
  orders,
  revenueCenters,
  menus,
})

const persistedReducer = persistReducer(persistAuthConfig, rootReducer)
const middleware = composeWithDevTools(applyMiddleware(thunkMiddleware))

export default () => {
  const store = createStore(persistedReducer, middleware)
  const persistor = persistStore(store)

  return { store, persistor }
}
